import axios from 'axios';
import environment from 'environment';

import { JsonResponse } from 'core/models/response';
import { Admin } from 'modules/admins/models/Admin';

export interface LoginResponse {
	phone_country_code: string;
	phone_number: string;
	ttl: number;
}

export interface VerifyOtpResponse extends Admin {
	authorization: string;
}

export interface VerifyOtpPayload {
	phone_country_code: string;
	phone_number: string;
	code: string;
	device_token: string;
}

export const onLogin = (email: string, password: string) => {
	return axios.post<JsonResponse<LoginResponse>>(`${environment.BASE_API_ENDPOINT}/admin/login`, {
		email,
		password,
	});
};

export const onVerifyOtp = (dataPayload: VerifyOtpPayload) => {
	return axios.post<JsonResponse<VerifyOtpResponse>>(`${environment.BASE_API_ENDPOINT}/admin/verify-otp-code`, {
		...dataPayload,
	});
};
